import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

/**
 * A suburb page's settings in its Page tab (#262): name and region (records not from the map), address, In a sentence,
 * description and Hide from search. Presentational: the host owns the form and works out the notes.
 */
@Component({
  selector: 'app-suburb-page-settings',
  templateUrl: './suburb-page-settings.component.html',
  styleUrls: ['./suburb-page.scss'],
})
export class SuburbPageSettingsComponent {
  @Input() form!: FormGroup;
  /** A suburb from the map: its name and region come from there. */
  @Input() fromMap = true;
  @Input() regionOptions: Array<{ label: string; value: string }> = [];
  /** Its region is fixed (live, or a sub-region with suburbs in it); why, when there's a reason to say. */
  @Input() regionNote = '';
  /** The address up to the slug. */
  @Input() pathPrefix = '';
  /** A live page being renamed: its old addresses will redirect (the old slug). */
  @Input() renamingFrom = '';
  /** A sub-region taking the address of an ABS suburb in its state. */
  @Input() slugClash = false;
  @Output() nameInput = new EventEmitter<void>();

  /** A placeholder can't be written literally in a template's text. */
  readonly whereToken = '{{suburb:where}}';

  invalid(name: string): boolean {
    const c = this.form.get(name);
    return !!c && c.invalid && c.touched;
  }
}
